import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-67ce037e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "common-top-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CommonTitle = _resolveComponent("CommonTitle");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_CommonTitle, null, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]),
    _: 3
  })]);
}